import { Injectable } from '@angular/core';

import { LanguageItem, TranslationsProvider } from '../i18n.service';
import { Translations } from '../i18n.tokens';

@Injectable()
export class MultilangTranslationService extends TranslationsProvider {
  public hasEditor: boolean = false;
  public defaultLocale: string;
  public locale: string;
  public availableLocales: string[] = [];

  private availableLanguagesList: LanguageItem[];
  private translations: Translations;

  constructor() {
    super();
    this.hasEditor = false;
  }

  public lookup(key: string): string | null {
    return this.translations[key];
  }

  public setTranslations(translations: Translations): void {
    this.translations = translations;
  }

  public setAvailableLanguagesList(languagesList: LanguageItem[]): void {
    this.availableLanguagesList = languagesList;
    this.availableLocales = this.availableLanguagesList.map(language => language.code);
  }

  public getAvailableLanguagesList(): LanguageItem[] {
    return this.availableLanguagesList;
  }

  public setLocale(locale: string): boolean {
    const canSet = !!this.availableLanguagesList.find(language => language.code === locale);
    if (canSet) {
      this.locale = locale;
      this.defaultLocale = locale;
      this.localeChanged.next(locale);
    }

    return canSet;
  }
}
